const cols = [
  {
    title: "关于歪歪",
    links: ["品牌介绍", "发展理念", "内容原则", "加入我们"],
  },
  {
    title: "产品服务",
    links: ["客户端下载", "会员权益", "充值服务", "网页版入口"],
  },
  {
    title: "帮助支持",
    links: ["常见问题", "帮助中心", "在线客服", "意见反馈"],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-200/50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-950">
                <i className="ri-voiceprint-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-foreground-50">
                歪歪<span className="text-primary-400">语音</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">
              歪歪语音平台，聚合高清语音连麦、在线开黑与互动直播，让每一份热爱都有回响。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-douban-line", "ri-bilibili-line", "ri-wechat-line"].map((icon) => (
                <a
                  key={icon}
                  href="#home"
                  aria-label="关注歪歪社交账号"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/60 text-foreground-300 hover:text-primary-300 hover:border-primary-400/60 transition-colors"
                >
                  <i className={`${icon} text-lg`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base text-foreground-50">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a href="#home" className="text-sm text-foreground-400 hover:text-primary-300 transition-colors">
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/70 pt-6">
          <p className="text-sm text-foreground-500">© 2026 歪歪语音平台 版权所有。</p>
          <p className="text-sm text-foreground-500">
            客服邮箱：<a href="mailto:service@yy-support.example.com" className="text-primary-300 hover:text-primary-200 transition-colors">service@yy-support.example.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}